export default __webpack_public_path__ + "static/media/jap-ecommerceImg_9.9699a244.png";